import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function CreatorStorySection() {
  return <section className="py-10 md:py-28 bg-charcoal relative overflow-hidden" data-id="element-45">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-sand/20 to-transparent" data-id="element-46"></div>
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-sand/20 to-transparent" data-id="element-47"></div>

      <div className="max-w-3xl mx-auto px-6" data-id="element-48">
        <FadeIn data-id="element-49">
          <div className="relative" data-id="element-50">
            <div className="absolute -left-4 top-0 bottom-0 w-[2px] bg-gradient-to-b from-sand/0 via-sand/40 to-sand/0 hidden md:block" data-id="element-51"></div>

            <div className="space-y-6 text-lg md:text-xl text-offwhite-dim leading-relaxed md:pl-8" data-id="element-52">
              <FadeIn delay={0.1} data-id="element-53">
                <p className="text-2xl md:text-3xl font-heading font-bold text-offwhite" data-id="element-54">
                  Pasé años rindiendo al máximo por afuera…
                </p>
                <p className="mt-2 text-amber font-medium text-xl" data-id="element-55">
                  y sintiéndome vacío por adentro.
                </p>
              </FadeIn>

              <FadeIn delay={0.2} data-id="element-56">
                <div className="space-y-3 py-4" data-id="element-57">
                  <p data-id="element-58">Ansiedad constante.</p>
                  <p data-id="element-59">Ruido mental que no paraba.</p>
                  <p data-id="element-60">Energía que se caía a las 3pm.</p>
                </div>
              </FadeIn>

              <FadeIn delay={0.3} data-id="element-61">
                <p data-id="element-62">
                  Hasta que entendí que no era un problema de{' '}
                  <span className="text-offwhite font-medium" data-id="element-63">disciplina</span>.
                </p>
                <p className="mt-3 text-xl font-heading font-bold text-sand" data-id="element-64">
                  Era un problema de regulación.
                </p>
              </FadeIn>

              <FadeIn delay={0.4} data-id="element-65">
                <p className="pt-4" data-id="element-66">
                  Cuando regulé el cuerpo y la mente al mismo tiempo, todo
                  cambió.
                </p>
              </FadeIn>

              <FadeIn delay={0.5} data-id="element-67">
                <div className="mt-6 pt-6 border-t border-charcoal-light" data-id="element-68">
                  <p className="text-offwhite font-medium" data-id="element-69">
                    Este es el sistema que usé.
                  </p>
                  <p className="text-sand font-heading font-bold text-xl mt-2" data-id="element-70">
                    Y ahora lo aplico con otros.
                  </p>
                </div>
              </FadeIn>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}